const formatarMatricula = matricula => {
  matricula = matricula.replace(/\D/g, '');

  const regex = new RegExp(`.{1,${4}}`, 'g');

  let matriculaFormatada = matricula.match(regex).join('-');

  if (matriculaFormatada.length > 6) {
    matriculaFormatada = matriculaFormatada.slice(0, -1);
  }

  return matriculaFormatada;
};

export default formatarMatricula;
